const API_URL = process.env.REACT_APP_API;

export const authorizedRequest = async (endpoint, options) => {
  const url = `${API_URL}/${endpoint}`;
  const response = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: sessionStorage.getItem("auth"),
    },
  });
  const responseData = await response.json();
  if (responseData.status === 500) {
    throw new Error(responseData.error);
  }
  return responseData;
};
